import { get } from '../utils/http';

const apiEndpoint = '/categories';

export async function getCategories() {
    let response = await get(apiEndpoint);
    return response.data;
}